export const LOAD_INFLUENCERS = 'Dyzio/Influencers/LOAD_INFLUENCERS';
export const LOAD_INFLUENCERS_SUCCESS = 'Dyzio/Influencers/LOAD_INFLUENCERS_SUCCESS';
export const LOAD_INFLUENCERS_ERROR = 'Dyzio/Influencers/LOAD_INFLUENCERS_ERROR';

export const LOAD_SINGLE_INFLUENCER = 'Dyzio/Influencers/LOAD_SINGLE_INFLUENCER';
export const LOAD_SINGLE_INFLUENCER_SUCCESS = 'Dyzio/Influencers/LOAD_SINGLE_INFLUENCER_SUCCESS';
export const LOAD_SINGLE_INFLUENCER_ERROR = 'Dyzio/Influencers/LOAD_SINGLE_INFLUENCER_ERROR';

export const SEARCH = 'Dyzio/Influencers/SEARCH';
export const SEARCH_ERROR = 'Dyzio/Influencers/SEARCH_ERROR';
export const SEARCH_SUCCESS = 'Dyzio/Influencers/SEARCH_SUCCESS';

export const ADD_INFLUENCER = 'Dyzio/Influencers/ADD_INFLUENCER';
export const ADD_INFLUENCER_EROR = 'Dyzio/Influencers/ADD_INFLUENCER_ERROR';
export const ADD_INFLUENCER_SUCCESS = 'Dyzio/Influencers/ADD_INFLUENCER_SUCCESS';

export const LOAD_ORGANISATION_NAME = 'Dyzio/Influencers/LOAD_ORGANISATION_NAME';
export const LOAD_ORGANISATION_NAME_SUCCESS = 'Dyzio/Influencers/LOAD_ORGANISATION_NAME_SUCCESS';
export const LOAD_ORGANISATION_NAME_ERROR = 'Dyzio/Influencers/LOAD_ORGANISATION_NAME_ERROR';



/** WEBPACK FOOTER **
 ** ./src/containers/influencers/constants.js
 **/